function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _superPropGet(t, o, e, r) { var p = _get(_getPrototypeOf(1 & r ? t.prototype : t), o, e); return 2 & r && "function" == typeof p ? function (t) { return p.apply(e, t); } : p; }
function _get() { return _get = "undefined" != typeof Reflect && Reflect.get ? Reflect.get.bind() : function (e, t, r) { var p = _superPropBase(e, t); if (p) { var n = Object.getOwnPropertyDescriptor(p, t); return n.get ? n.get.call(arguments.length < 3 ? e : r) : n.value; } }, _get.apply(null, arguments); }
function _superPropBase(t, o) { for (; !{}.hasOwnProperty.call(t, o) && null !== (t = _getPrototypeOf(t));); return t; }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
import { AbstractPublisherTool } from '../../../../framework/publisher2/tools/AbstractPublisherTool';
import { ToolbarToolComponent } from './ToolbarToolComponent';
import { ToolbarToolHandler } from './ToolbarToolHandler';
var ToolbarTool = /*#__PURE__*/function (_AbstractPublisherToo) {
  function ToolbarTool() {
    var _this;
    _classCallCheck(this, ToolbarTool);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, ToolbarTool, [].concat(args));
    _this.index = 20;
    _this.group = 'tools';
    _this.handler = new ToolbarToolHandler(_this);
    return _this;
  }
  _inherits(ToolbarTool, _AbstractPublisherToo);
  return _createClass(ToolbarTool, [{
    key: "init",
    value: function init(data) {
      var _this$state;
      _superPropGet(ToolbarTool, "init", this, 3)([data]);
      var buttons = (_this$state = this.state) === null || _this$state === void 0 || (_this$state = _this$state.pluginConfig) === null || _this$state === void 0 ? void 0 : _this$state.buttons;
      if (!buttons) {
        return;
      }
      var handlerConfig = {
        history_forward: false,
        history_back: false,
        measureline: false,
        measurearea: false
      };
      var plugin = this.getPlugin();
      buttons.forEach(function (key) {
        handlerConfig[key] = true;
        plugin.addToolButton(key);
      });
      this.handler.init(handlerConfig);
    }
  }, {
    key: "getTool",
    value: function getTool() {
      var state = this.handler.getState();
      var buttons = Object.keys(state).filter(function (key) {
        return !!state[key];
      });
      return {
        id: 'Oskari.mapframework.bundle.mapmodule.plugin.PublisherToolbarPlugin',
        title: Oskari.getMsg('MapModule', 'publisherTools.PublisherToolbarPlugin.toolLabel'),
        config: _objectSpread(_objectSpread({}, this.state.pluginConfig || {}), {}, {
          toolbarId: 'PublisherToolbar',
          buttons: buttons || {}
        })
      };
    }
  }, {
    key: "getComponent",
    value: function getComponent() {
      return {
        component: ToolbarToolComponent,
        handler: this.handler
      };
    }

    /**
     * Get values.
     * @method getValues
     * @public
     *
     * @returns {Object} tool value object
     */
  }, {
    key: "getValues",
    value: function getValues() {
      if (!this.isEnabled()) {
        return null;
      }
      var buttons = [];
      var state = this.handler.getState();
      for (var toolName in state) {
        if (state[toolName]) {
          buttons.push(toolName);
        }
      }
      var pluginConfig = this.getPlugin().getConfig();
      pluginConfig.buttons = buttons;
      var retValue = {
        configuration: {
          mapfull: {
            conf: {
              plugins: [{
                id: this.getTool().id,
                config: pluginConfig
              }]
            }
          },
          toolbar: {
            conf: {
              history: false,
              basictools: false,
              viewtools: false
            }
          }
        }
      };
      return retValue;
    }
  }, {
    key: "hasActiveTools",
    value: function hasActiveTools() {
      var state = this.handler.getState();
      return Object.keys(state).some(function (toolName) {
        return state[toolName] === true;
      });
    }
  }]);
}(AbstractPublisherTool); // Attach protocol to make this discoverable by Oskari publisher
Oskari.clazz.defineES('Oskari.publisher.ToolbarTool', ToolbarTool, {
  protocol: ['Oskari.mapframework.publisher.Tool']
});
export { ToolbarTool };